import { ICooperationPartner } from '@alberta/konexi-shared';
import { ISearchable } from 'src/app/common/contracts/components/searchable';

import { AggregateRoot } from '../aggregate-root';

export class CooperationPartnerDto extends AggregateRoot implements ICooperationPartner, ISearchable {
  public name: string;
  public address: string;
  public postalCode: string;
  public city: string;
  public phone: string;
  public fax: string;
  public email: string;
  public website: string;
  public externalReference: string;

  get displayText(): string {
    return this.name;
  }
}
